import { createContext, useContext } from "react";

import SampleCons from "../constants/sample";

import { find } from "lodash";

const ParamsContext = createContext();

export function ParamsProvider(props) {
  const coloursList = SampleCons.COLOURS;
  const texturesList = SampleCons.TEXTURES;
  const adverseList = SampleCons.AR_INTERVENTION;
  const analyteNames = SampleCons.ANALYTE_NAMES;

  // TODO: remove getAnalyteName and addSpaces once legacy `substance` format is retired
  // and all findings use substanceCustomer for display
  const getAnalyteName = (analyte) => {
    return (
      analyteNames.find((item) => item.modelName === analyte)?.displayName ||
      addSpaces(analyte)
    );
  };

  //add spaces between camel case
  const addSpaces = (string) => {
    return string.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
  };

  function getColour(id) {
    for (const item of coloursList) {
      for (const c of item.colours) {
        if (c.id.includes(id)) {
          const colour = { ...c };
          if (!colour.label) {
            colour.label = item.label;
          }
          return colour;
        }
      }
    }
    return undefined;
  }

  // Function to get texture by ID
  // This function iterates through the texturesList to find the texture with the matching ID
  function getTexture(texture) {
    if (!texture) return {};

    const found = texturesList.find((item) => item.id === texture.id);
    if (found) {
      return {
        ...found,
        description: texture.description ? texture.description : "",
      };
    }
    return texture;
  }

  const getAdverse = (categories) => {
    const reactions = [];
    if (categories.length > 0) {
      for (let i = 0; i < categories.length; i++) {
        reactions.push(
          find(adverseList, ["id", categories[i].categoryId]).label
        );
      }
      return reactions;
    }
    return reactions;
  };

  return (
    <ParamsContext.Provider
      value={{ getColour, getTexture, getAdverse, getAnalyteName }}
    >
      {props.children}
    </ParamsContext.Provider>
  );
}

export const useParamsContext = () => {
  const { getColour, getTexture, getAdverse, getAnalyteName } =
    useContext(ParamsContext);
  return { getColour, getTexture, getAdverse, getAnalyteName };
};
